var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"drag",rawName:"v-drag:target",value:({
    draggable: _vm.rootTable.columnDraggable,
    dragstart: _vm.dragstartHandler,
    drag: _vm.dragHandler,
    dragend: _vm.dragendHandler,
  }),expression:"{\n    draggable: rootTable.columnDraggable,\n    dragstart: dragstartHandler,\n    drag: dragHandler,\n    dragend: dragendHandler,\n  }",arg:"target"}],ref:"target",staticClass:"mm-thead-dragbar",class:{
    'mm-thead-dragbar--disabled': !_vm.draggable,
    'mm-thead-dragbar__prev': _vm.prevColumn,
    'mm-thead-dragbar__next': _vm.nextColumn,
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }